import React from 'react'
import { Moment } from '../../../Libs/moment'
import { TextField as MuiTextField, Theme, TextFieldProps, useMediaQuery } from '@mui/material'
import { useStyles } from '../styles'
import { useCustomTranslation } from '../../../Hooks/useCustomTranslation'

import {
  DesktopDateTimePicker as KeyboardDateTimePicker,
  DateTimePicker as MuiDateTimePicker,
  DateTimePickerProps as MuiDateTimePickerProps,
  DesktopDateTimePickerProps as KeyboardDateTimePickerProps,
} from '@mui/x-date-pickers'

/**
 * Keyboard Date Picker Component
 */
export interface DateTimePickerProps {
  onChange?: (date: Moment | null) => void
  value?: Moment
  label?: string
  variant?: TextFieldProps['variant']
  required?: boolean
  disabled?: boolean
  minDate?: Moment
  inputFormat?: string
  iconPaddingRight?: string
  className?: string
  error?: boolean
  helperText?: string
}

export const DateTimePicker: React.VFC<DateTimePickerProps> = ({
  onChange,
  value,
  label,
  disabled,
  minDate,
  variant = 'outlined',
  required = false,
  inputFormat,
  iconPaddingRight,
  className,
  error,
  helperText,
}) => {
  const { t } = useCustomTranslation()
  const downMd = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'))
  const { classes, cx } = useStyles({ iconPaddingRight })
  const parameter: Partial<MuiDateTimePickerProps<Moment, Moment> & KeyboardDateTimePickerProps<Moment, Moment>> = {
    inputFormat: inputFormat ?? t('common.format.dateTimeWithoutSeconds'),
    ampm: false,
    value,
    onChange: (date: Moment | null) => onChange?.(date),
    minDate,
    label,
  }

  return downMd ? (
    <MuiDateTimePicker
      {...(parameter as MuiDateTimePickerProps<Moment, Moment>)}
      renderInput={props => (
        <MuiTextField
          {...props}
          variant={variant}
          required={required}
          fullWidth
          disabled={disabled}
          className={cx(classes.datePicker, className)}
          error={error}
          helperText={helperText}
        />
      )}
    />
  ) : (
    <KeyboardDateTimePicker
      {...(parameter as KeyboardDateTimePickerProps<Moment, Moment>)}
      renderInput={props => (
        <MuiTextField
          {...props}
          variant={variant}
          required={required}
          fullWidth
          disabled={disabled}
          className={cx(classes.datePicker, className)}
          error={error}
          helperText={helperText}
        />
      )}
    />
  )
}
